(() => {
  if (window.__everacsPdpAssistLoaded) return;
  window.__everacsPdpAssistLoaded = true;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const makePolicyLink = (href, label) => {
    if (!href) return null;

    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    link.dataset.everacsInlinePolicyLink = 'true';
    link.style.color = '#515154';
    link.style.fontWeight = '600';
    link.style.textDecoration = 'underline';
    link.style.textDecorationThickness = '1px';
    link.style.textUnderlineOffset = '3px';
    return link;
  };

  const syncPolicyLinks = (section) => {
    const source = section.querySelector('[data-everacs-policy-source]');
    if (!source) return;

    const shippingUrl = source.dataset.shippingUrl || '';
    const returnUrl = source.dataset.returnUrl || '';
    if (!shippingUrl && !returnUrl) return;

    const deliveryDetails = Array.from(section.querySelectorAll('details')).find((details) => {
      const summary = details.querySelector('summary');
      return normalize(summary?.textContent).includes('delivery & returns');
    });

    const content = deliveryDetails?.querySelector('.details-content');
    if (!content) return;

    const shippingSentence =
      'Standard delivery within Pakistan is PKR 200. Orders of PKR 1,000 or more qualify for free delivery. The final delivery charge shown at checkout applies.';
    const returnSentence =
      'Return requests must be made within 7 days of delivery and are reviewed under the store policy.';

    const currentText = String(content.textContent || '').replace(/\s+/g, ' ').trim();
    if (!currentText.includes(shippingSentence) || !currentText.includes(returnSentence)) return;

    const wrapper = document.createElement('div');
    wrapper.dataset.everacsPolicyCopy = 'true';

    const shippingParagraph = document.createElement('p');
    shippingParagraph.append(document.createTextNode(shippingSentence));
    const shippingLink = makePolicyLink(shippingUrl, 'Read Shipping Policy');
    if (shippingLink) shippingParagraph.append(document.createTextNode(' '), shippingLink);

    const returnParagraph = document.createElement('p');
    returnParagraph.style.marginTop = '8px';
    returnParagraph.append(document.createTextNode(returnSentence));
    const returnLink = makePolicyLink(returnUrl, 'Read Return Policy');
    if (returnLink) returnParagraph.append(document.createTextNode(' '), returnLink);

    wrapper.append(shippingParagraph, returnParagraph);
    content.replaceChildren(wrapper);
  };

  const sync = () => {
    document.querySelectorAll('[data-testid="product-information"]').forEach((section) => {
      syncPolicyLinks(section);
    });
  };

  const scheduleSync = () => requestAnimationFrame(() => requestAnimationFrame(sync));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:product:select', (event) => {
    if (event?.promise?.finally) event.promise.finally(scheduleSync);
    else scheduleSync();
  });
})();
